import React from 'react';
import CalculusOfCompassion from '../components/CalculusOfCompassion';

function CalculusOfCompassionPage() {
  return <CalculusOfCompassion />;
}

export default CalculusOfCompassionPage;
